import React from "react";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { debounce, size, get, uniqBy, map, filter, includes } from "lodash";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";

import { fetchPost } from "../../api/fetch";
import FormSection from "./FormSection";
import ProfileSearchCreateProfile from "./ProfileSearchCreateProfile";
import ProfileMatch from "../SiteEntranceExit/CorrectConfirmValue/ProfileMatch";
import images from "../../assets/img/images";
import colors from "../../assets/style/colors";
import ProfileMatchExpress from "../SiteEntranceExit/CorrectConfirmValue/ProfileMatchExpress";
import { getSiteName } from "../../utils/site";

const styles = {
  resultsContainer: {
    maxHeight: "272px",
    overflow: "auto",
    position: "absolute",
    top: "58px",
    boxShadow: `0px 2px 9px 2px ${colors.black23}`,
    zIndex: 8000,
    backgroundColor: colors.white,
  },
  viewMore: {
    color: colors.primary,
    padding: "16px 8px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  profilesOnSite: {
    color: colors.black38,
    fontStyle: "italic",
    padding: "8px",
  },
};

const ProfileSearchInput = (props) => {
  const {
    classes,
    companies,
    profileType,
    title,
    selectProfile,
    selectedProfile,
    autoFocus = false,
    flow
  } = props;
  const [searchValue, setSearchValue] = React.useState();
  const [searchResults, setSearchResults] = React.useState();
  const [createdProfile, setCreatedProfile] = React.useState();

  // Only used when props.siteFilter
  const [viewAll, setViewAll] = React.useState(false);

  const setFormValue = (id, index, value) => {
    setSearchValue(value);
    if (!value) {
      setSearchResults();
    } else if (size(value) > 2) {
      debouncedSearch(value, profileType);
    }
  };



  const debouncedSearch = React.useCallback(
    debounce(async (value = searchValue, profileType) => {
      try {
        let body = {
          search_text: value,
        };
        if (!props.allTypes) {
          body.types = [profileType];
        }
        let res = await fetchPost("profiles/search", body);
        res = uniqBy(res, (item) => get(item, ["id"]));
        if (props.excludeProfileIds) {
          res = filter(
            res,
            (item) => !includes(props.excludeProfileIds, get(item, ["id"]))
          );
        }
        setSearchResults(res);
      } catch (e) {
        console.log(e);
      }
    }, 500),
    []
  );

  const renderProfileMatch = (profile) => {

    return (
      <ProfileMatchExpress
        key={profile.id}
        profile={profile}
        onClick={() => {
          selectProfile(profile);
          if (!flow) {
            localStorage.setItem("prof1", profile.id)
          }
          setSearchResults();
          setSearchValue(
            props.noProfileDisplay
              ? `${get(profile, ["firstname"])} ${get(profile, ["lastname"])}`
              : null
          );
        }}
        style={{
          padding: 0,
          cursor: "pointer",
          borderTop: "none",
          borderLeft: "none",
          borderRight: "none",
          marginBottom: "4px",
        }}
      />
    );
  };

  return (
    <Box
      style={{
        position: "relative",
        minHeight: props.noMinHeight ? "" : props.minHeight || "191px",
        ...props.style,
      }}
    >
      <FormSection
        style={{ maxWidth: get(props, ["sizes", "input"]) || "" }}
        formValue={[searchValue]}
        setFormValue={setFormValue}
        noLabel={props.noLabel}
        title={title}
        title2={props.title2}
        id={props.id || `field${profileType}`}
        autoComplete="new-password"
        startAdornment={
          <img
            src={images.searchIcon}
            alt="search"
            width="17px"
            height="17px"
          />
        }
        endAdornment={
          size(searchValue) > 0 ? (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                onClick={() => {
                  setSearchResults();
                  setSearchValue();
                  selectProfile();
                }}
                style={{ opacity: "0.54" }}
              >
                <img
                  src={images.closeIcon}
                  alt="search_close"
                  width="12px"
                  height="12px"
                />
              </IconButton>
            </InputAdornment>
          ) : (
            <></>
          )
        }
        options={{
          required: props.required,
          autoFocus: autoFocus,
          placeholder: props.placeholder,
          startImg: props.noIcon
            ? null
            : profileType === 1
              ? images.humanIconBlack
              : profileType === 2
                ? images.truckIconBlack
                : profileType === 3
                  ? images.trailerIconBlack
                  : profileType === 4
                    ? images.containerIconBlack
                    : null,
        }}
      />
      {searchResults !== undefined && (
        <Grid
          container
          direction="column"
          className={classes.resultsContainer}
          wrap="nowrap"
          style={{
            maxWidth: get(props, ["sizes", "inputDropdown"]),
            maxHeight: get(props, ["sizes", "inputDropdownHeight"]),
            overflowX: "hidden"
          }}
        >
          <Grid item style={{ margin: "10px 0px" }}>
            {(
              <ProfileSearchCreateProfile
                profileType={profileType}
                handleProfileCreation={(p) => {
                  selectProfile(p);
                  setSearchResults();
                  setSearchValue();
                  setCreatedProfile(true);
                }}
                flow={flow}
                express={props.express}
                newProfilePhotos={props.newProfilePhotos}
              />
            )}
          </Grid>
          {size(searchResults) === 0 ? (
            <span
              className="text-italic text-54"
              style={{ height: "36px", paddingLeft: "10px" }}
            >
              {I18n.get("site_noProfileFound")}
            </span>
          ) : props.siteFilter ? (
            <>
              <Box
                className={classes.profilesOnSite}
                style={{ marginTop: "-16px" }}
              >
                {`${I18n.get("site_profilesOn")} ${getSiteName(
                  props.siteFilter,
                  companies
                )}`}
              </Box>
              {map(
                filter(searchResults, (p) => p.site_id === props.siteFilter),
                (profile) => renderProfileMatch(profile)
              )}
              {viewAll ? (
                <>
                  <Box className={classes.profilesOnSite}>
                    {I18n.get("site_profilesOnOtherSites")}
                  </Box>
                  {map(
                    filter(
                      searchResults,
                      (p) => p.site_id !== props.siteFilter
                    ),
                    (profile) => renderProfileMatch(profile)
                  )}
                </>
              ) : (
                <Box
                  className={classes.viewMore}
                  component="span"
                  onClick={() => setViewAll(true)}
                >
                  {I18n.get("site_viewMore")}
                </Box>
              )}
            </>
          ) : (
            map(searchResults, (profile) => renderProfileMatch(profile))
          )}
        </Grid>
      )}
      {!props.noProfileDisplay &&
        selectedProfile &&
        (props.express ? (
          <ProfileMatchExpress
            profile={selectedProfile}
            allowAnyImage={createdProfile}
            style={{
              border: "none",
              backgroundColor:
                get(props, ["profileMatchProps", "backgroundColor"]) ||
                colors.lightGrey,
              padding: 0,
              maxWidth: get(props, ["sizes", "profile"]),
            }}
          />
        ) : (
          <ProfileMatch
            profile={selectedProfile}
            style={{
              marginTop: "10px",
              border: "none",
              backgroundColor: colors.lightGrey,
              padding: "8px",
              maxWidth: get(props, ["sizes", "profile"]),
            }}
          />
        ))}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    companies: get(state, ["user", "companies"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(ProfileSearchInput));
